var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2241 68.843V127.365",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.436 68.8431L82.8646 36.2531C77.6614 32.9 70.9985 32.9 65.7954 36.2531L15.2241 68.8431",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.436 68.8431L82.8646 36.2531C77.6614 32.9 70.9985 32.9 65.7954 36.2531L15.2241 68.8431",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.436 127.365V68.843",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7501 125.239L115.91 125.239C120.284 125.239 123.83 121.666 123.83 117.259L123.83 59.402C123.83 54.9946 120.284 51.4218 115.91 51.4218L32.7501 51.4218C28.376 51.4218 24.8301 54.9946 24.8301 59.402L24.8301 117.259C24.8301 121.666 28.376 125.239 32.7501 125.239Z",
    fill: "url(#paint0_linear_894_46033)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.436 68.843L83.6672 95.2921",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9924 95.2921L15.2241 68.843",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.436 127.365L82.8646 94.7748C77.6614 91.4217 70.9985 91.4217 65.7954 94.7748L15.2241 127.365",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2241 127.365V132.02C15.2241 136.427 18.77 140 23.1441 140H125.516C129.89 140 133.436 136.427 133.436 132.02V127.365",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.514 52.7731C137.263 52.7731 138.68 51.3452 138.68 49.5837C138.68 47.8222 137.263 46.3943 135.514 46.3943C133.766 46.3943 132.349 47.8222 132.349 49.5837C132.349 51.3452 133.766 52.7731 135.514 52.7731Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.922 44.9251C113.843 44.9251 114.59 44.1728 114.59 43.2449C114.59 42.3169 113.843 41.5647 112.922 41.5647C112.001 41.5647 111.255 42.3169 111.255 43.2449C111.255 44.1728 112.001 44.9251 112.922 44.9251Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 41C41.7761 41 42 40.7761 42 40.5C42 40.2239 41.7761 40 41.5 40C41.2239 40 41 40.2239 41 40.5C41 40.7761 41.2239 41 41.5 41Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.25 28.0149C50.8903 28.0149 52.22 26.6751 52.22 25.0224C52.22 23.3696 50.8903 22.0298 49.25 22.0298C47.6097 22.0298 46.28 23.3696 46.28 25.0224C46.28 26.6751 47.6097 28.0149 49.25 28.0149Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140 16.6457L138.35 14.9832L136.7 16.6457L138.35 18.3082L140 16.6457Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3001 54.5517L9.65015 52.8892L8.00014 54.5517L9.65015 56.2143L11.3001 54.5517Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.84 32.0051L21.6395 34.7376C21.3613 35.083 21.3613 35.5774 21.6395 35.9228L23.84 38.6553L21.1281 36.4381C20.7854 36.1578 20.2946 36.1578 19.9519 36.4381L17.24 38.6553L19.4405 35.9228C19.7186 35.5774 19.7186 35.083 19.4405 34.7376L17.24 32.0051L19.9519 34.2224C20.2946 34.5026 20.7854 34.5026 21.1281 34.2224L23.84 32.0051Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.341 35.3303L21.0025 35.7958L20.5405 45.2053L20.0785 35.7958L10.74 35.3303L20.0785 34.8648L20.5405 25.4553L21.0025 34.8648L30.341 35.3303Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6491 30.1018L98.3894 31.6659C98.2302 31.8636 98.2302 32.1467 98.3894 32.3444L99.6491 33.9085L98.0967 32.6393C97.9005 32.4789 97.6196 32.4789 97.4234 32.6393L95.8711 33.9085L97.1307 32.3444C97.2899 32.1467 97.2899 31.8636 97.1307 31.6659L95.8711 30.1018L97.4234 31.371C97.6196 31.5314 97.9005 31.5314 98.0967 31.371L99.6491 30.1018Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.37 32.0052L98.0244 32.2717L97.7599 37.6578L97.4954 32.2717L92.1499 32.0052L97.4954 31.7387L97.7599 26.3525L98.0244 31.7387L103.37 32.0052Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M126.273 24.8649L122.923 21.4893L119.573 24.8649L122.923 28.2406L126.273 24.8649Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M122.922 8L123.469 22.0403H122.375L122.922 8Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M122.922 41.6479L123.469 27.6077H122.375L122.922 41.6479Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M139.62 24.824L125.685 24.2729V25.375L139.62 24.824Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M106.226 24.824L120.16 24.2729V25.375L106.226 24.824Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_894_46033",
    x1: 74.3301,
    y1: 34.6761,
    x2: 74.3301,
    y2: 134.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186756,
    stopColor: "#A8D4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327588,
    stopColor: "#A1CBA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453409,
    stopColor: "#94BB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570427,
    stopColor: "#82A488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681383,
    stopColor: "#6A866F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787745,
    stopColor: "#4D6251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890546,
    stopColor: "#2B372D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988007,
    stopColor: "#050605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.6b0656811a75c778acb39e0346a29bc1.svg";
export { ForwardRef as ReactComponent };